import { Button } from '@material-ui/core'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { EnumClientTypes } from '../../api/Argentia/enums/enumClientTypes'
import Page from '../../components/page/page'
import PageHeader from '../../components/page/pageHeader'
import { GlobalNotification, NonAuthRoutes } from '../../model'
import { ConceptsTable } from './components/conceptsTable/conceptsTable'

export interface ConceptsPageProps {
  location: { state: { clientType: EnumClientTypes } }
}

export const ConceptsPage: React.FC<ConceptsPageProps> = props => {
  const [isFetching, setIsFetching] = useState<boolean>(false)
  const [globalNotification, setGlobalNotification] = useState<GlobalNotification | undefined>(
    undefined
  )
  const [t] = useTranslation(['globalerisLibrary', 'concepts', 'enums', 'clientsMod'])
  const clientType = props.location.state.clientType ?? EnumClientTypes.FINAL_CLIENT
  const history = useHistory()

  // #region Handlers Starts
  const onTableFetching = (childIsFetching: boolean) => {
    setIsFetching(childIsFetching)
  }
  // #endregion Handlers Ends

  // #region Functions Starts
  // #endregion Functions Ends

  // #region Form Definition Starts
  // #endregion Form Definition Ends

  // #region DataTable Config Starts
  // #endregion DataTable Config Ends

  // #region Hooks Starts
  // #endregion Hooks Ends

  return (
    <Page notification={globalNotification}>
      <PageHeader title={t('concepts:title')}>
        <Button
          size="small"
          variant="text"
          color="primary"
          onClick={() => {
            history.push(NonAuthRoutes.Client)
          }}
        >
          {t('clientsMod:buttons.back')}
        </Button>
        <Button
          size="small"
          variant="contained"
          disabled={isFetching}
          color="primary"
          onClick={() => {
            switch (clientType) {
              case EnumClientTypes.WHOLESALER:
                history.push(NonAuthRoutes.Trader)
                break
              case EnumClientTypes.COMMERCIAL:
                history.push(NonAuthRoutes.ConceptCommercial)
                break
              default:
                history.push(NonAuthRoutes.Concept)
                break
            }
          }}
        >
          {t('clientsMod:buttons.oldConceptPage')}
        </Button>
      </PageHeader>
      <ConceptsTable clientType={clientType} onFetching={onTableFetching} />
    </Page>
  )
}
